export default __webpack_public_path__ + "static/media/about1.21894813.jpg";